<script setup lang="ts">
import type { DirectusImage } from '~/models/directus/directusImage.model'

const props = defineProps<{
  image: DirectusImage
  width?: number
  height?: number
}>()

const directusUrl = computed(() => {
  return `${props.image.id}`
})

const hasLoaded = ref(false)
</script>

<template>
  <NuxtImg
    v-show="hasLoaded"
    provider="directus"
    class="h-full w-full object-cover"
    :src="directusUrl"
    :alt="image.title"
    :width="width"
    @load="hasLoaded = true"
  />
</template>
